import { gql } from 'graphql-request';

export const SEND_EMAIL_TO_AUTHORITY = gql`
  mutation SendEmailToAuthority($email: String!, $cert: String!, $poaID: String!) {
    corePOA {
      sendPOANotificationToAuthority(email: $email, cert: $cert, poaID: $poaID)
    }
  }
`;
